import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useContext, useState } from "react";
import AppLayout from "../../Components/AppLayout";
import { UserContext } from "../../App";
import QRScan from "../../Pages/Public/QRScan";
import FleetManagerRevise from "../../Pages/Public/FleetManagerRevise";
import FuelVendorRevise from "../../Pages/Public/FuelVendorRevise";
import PaymentSuccess from "../../Pages/Public/PaymentSuccess";
import PaymentFailed from "../../Pages/Public/PaymentFailed";
import PUBLIC_STANDALONE_PATHS from "../../Utlis/PublicStandalonePaths";

import PublicRoutes from "../PublicRoutes";
import FleeiqAdminRoutes from "../FleeiqAdminRoutes";
import FleetManagerRoutes from "../FleetManagerRoutes";
import FuelVendorRoutes from "../FuelVendorRoutes";

const AppRoutes = () => {
  let routesComponent;
  const { userData } = useContext(UserContext);
  const [user, setUser] = useState("public_manager");

  if (
    PUBLIC_STANDALONE_PATHS.some((path) =>
      window.location.pathname.startsWith(path),
    )
  ) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/qr-scan" element={<QRScan />} />
          <Route
            path="/fleet-manager/revise"
            element={<FleetManagerRevise />}
          />
          <Route path="/fuel-vendor/revise" element={<FuelVendorRevise />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/failed" element={<PaymentFailed />} />
        </Routes>
      </BrowserRouter>
    );
  }

  switch (userData?.tenant_type) {
    case "admin":
      routesComponent = (
        <AppLayout setUser={setUser} userType="admin">
          <FleeiqAdminRoutes setUser={setUser} />
        </AppLayout>
      );
      break;

    case "fleet_manager":
      routesComponent = (
        <AppLayout setUser={setUser} userType="manager">
          <FleetManagerRoutes setUser={setUser} />
        </AppLayout>
      );
      break;

    case "fuel_vendor":
      routesComponent = (
        <AppLayout setUser={setUser} userType="vendor">
          <FuelVendorRoutes setUser={setUser} />
        </AppLayout>
      );
      break;

    default: {
      const portal =
        user === "public_admin"
          ? "admin"
          : user === "public_vendor"
            ? "vendor"
            : "manager";
      routesComponent = <PublicRoutes setUser={setUser} portal={portal} />;
      break;
    }
  }

  return <BrowserRouter>{routesComponent}</BrowserRouter>;
};

export default AppRoutes;
